import type { RouteRecordRaw } from 'vue-router'

export const integrationsRoutes: RouteRecordRaw[] = [
  {
    path: '/integrations/fitpass',
    name: 'integrations-fitpass',
    component: () => import('./views/FitpassIntegrationView.vue'),
    meta: { requiresAuth: true, roles: ['owner', 'admin'] },
  },
  {
    path: '/integrations/totalpass',
    name: 'integrations-totalpass',
    component: () => import('./views/TotalPassIntegrationView.vue'),
    meta: { requiresAuth: true, roles: ['owner', 'admin'] },
  },
  {
    path: '/integrations/availability',
    name: 'integrations-availability',
    component: () => import('./views/ExternalAvailabilityView.vue'),
    meta: { requiresAuth: true, roles: ['owner', 'admin'] },
  },
  {
    path: '/integrations/incidents',
    name: 'integrations-incidents',
    component: () => import('./views/IntegrationsIncidentsView.vue'),
    meta: { requiresAuth: true, roles: ['owner', 'admin'] },
  },
  {
    path: '/integrations/logs',
    name: 'integrations-logs',
    component: () => import('./views/IntegrationsLogsView.vue'),
    meta: { requiresAuth: true, roles: ['owner', 'admin'] },
  },
  {
    path: '/integrations/wellhub/issues',
    name: 'integrations-wellhub-issues',
    component: () => import('./views/WellhubIssuesView.vue'),
    meta: { requiresAuth: true, roles: ['owner', 'admin'] },
  },
  {
    path: '/integrations/wellhub',
    name: 'integrations-wellhub',
    component: () => import('./views/WellhubIntegrationView.vue'),
    meta: { requiresAuth: true, roles: ['owner', 'admin'] },
  },
]
